import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import SoundToggle from './SoundToggle';

const ADMIN_EMAILS = ['mjonthemove@gmail.com'];

export default function Nav() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const isAdmin  = user && ADMIN_EMAILS.includes(user.email);

  async function handleSignOut() {
    await signOut();
    navigate('/');
  }

  return (
    <nav className="nav">
      <Link to={user ? '/feed' : '/'} className="nav-logo">
        <span className="valid">valid</span>
        <span className="or">or</span>
        <span className="mid">mid</span>
      </Link>

      <div className="nav-actions">
        <SoundToggle />
        {user ? (
          <>
            {isAdmin && (
              <Link to="/admin" className="nav-link" style={{ color: 'var(--gold)' }}>
                Admin
              </Link>
            )}
            <Link to="/profile"  className="nav-link">Profile</Link>
            <Link to="/settings" className="nav-link">Settings</Link>
            <button className="btn-ghost" onClick={handleSignOut} style={{ padding: '6px 14px', fontSize: '0.85rem' }}>
              Out
            </button>
          </>
        ) : (
          <>
            <Link to="/login"    className="nav-link">Sign in</Link>
            <Link to="/register" className="nav-link" style={{ color: 'var(--gold)' }}>Join</Link>
          </>
        )}
      </div>
    </nav>
  );
}
